import React, { useState } from "react";
import { C, BG, BO } from "../constants/baziData";
import { API } from "../constants/config";

// ── Consultant Booking page ───────────────────────────────────────────────────
function ConsultantBookingPage({lang="en",user,setPage}){
  const [form,setForm]=useState({name:user?.email?.split("@")[0]||"",email:user?.email||"",date:"",time:"",concern:"",message:""});
  const [submitted,setSubmitted]=useState(false);
  const [loading,setLoading]=useState(false);
  const set=k=>e=>setForm({...form,[k]:e.target.value});

  const timeSlots=["09:00","10:00","11:00","13:00","14:00","15:00","16:00","17:00","19:00","20:00"];

  const consultants=[
    {name:"Master Jack Chen",title:lang==="zh"?"首席能量顾问 · 八字/紫微专家":"Chief Energy Consultant · Bazi & Ziwei Expert",
     specialty:lang==="zh"?"20年八字命理、藏传佛教修持指导经验":"20 years in Bazi destiny analysis & Tibetan Buddhist practice guidance",
     avatar:"JC",color:C.gold},
    {name:"Dr. Sarah Lin",title:lang==="zh"?"高级命理师 · 五行养生专家":"Senior Practitioner · Five Elements Wellness",
     specialty:lang==="zh"?"中医五行与现代整合健康":"TCM Five Elements & modern integrative health",
     avatar:"SL",color:C.cyan},
    {name:"Lama Tenzin",title:lang==="zh"?"闭关指导师 · 本尊修持导师":"Retreat Director · Deity Yoga Guide",
     specialty:lang==="zh"?"普巴金刚/大威德/绿度母修持传承":"Vajrakilaya, Yamantaka & Green Tara lineage holder",
     avatar:"LT",color:C.sage},
  ];

  const handleSubmit=async()=>{
    if(!form.name||!form.email||!form.date||!form.time)return;
    setLoading(true);
    if(!user||(user.tier !== "pro" && !["L2","L3","L4"].includes(user.tier))){
      setLoading(false);
      if(!user){setPage("register");return;}
      try{
        const token=localStorage.getItem("lumina_token");
        const r=await fetch(`${API}/payments/upgrade/L2`,{
          method:"POST",headers:{"Authorization":`Bearer ${token}`,"Content-Type":"application/json"},
        });
        const d=await r.json();
        if(d.checkout_url)window.location.href=d.checkout_url;
      }catch(e){alert(e.message);}
      return;
    }
    setTimeout(()=>{setSubmitted(true);setLoading(false);},1200);
  };

  if(submitted)return(
    <div style={{maxWidth:600,margin:"60px auto",padding:"0 20px",textAlign:"center"}}>
      <div style={{background:C.panel,border:`0.5px solid ${C.sage}`,borderRadius:14,padding:40}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:"rgba(52,211,153,.12)",border:"1px solid rgba(52,211,153,.3)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 20px",fontSize:28,color:C.sage}}>✓</div>
        <div style={{fontSize:22,color:C.sage,fontFamily:"'Inter','Montserrat',sans-serif",marginBottom:12}}>{lang==="zh"?"预约成功":"Booking Confirmed"}</div>
        <div style={{fontSize:15,color:C.mist2,lineHeight:1.8,marginBottom:8}}>
          {lang==="zh"
            ?`您的专家咨询已预约 ${form.date} ${form.time} (EST)。确认邮件已发送至 ${form.email}。`
            :`Your expert consultation is booked for ${form.date} at ${form.time} (EST). A confirmation email has been sent to ${form.email}.`}
        </div>
        <div style={{fontSize:13,color:C.mist4,marginBottom:24}}>{lang==="zh"?"我们的顾问将在24小时内通过邮件确认详细信息。":"Our consultant will confirm details via email within 24 hours."}</div>
        <div style={{display:"flex",gap:10,justifyContent:"center"}}>
          <button style={BO} onClick={()=>setPage("audit")}>{lang==="zh"?"生成命盘报告":"Generate Audit"}</button>
          <button style={{...BO,background:C.gold,color:C.bg,border:"none"}} onClick={()=>{setSubmitted(false);setForm({...form,date:"",time:"",message:""});}}>
            {lang==="zh"?"再次预约":"Book Another"}
          </button>
        </div>
      </div>
    </div>
  );

  return(
    <div style={{maxWidth:900,margin:"0 auto",padding:"40px 20px"}}>
      <div style={{textAlign:"center",marginBottom:32}}>
        <div style={{fontSize:26,color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",letterSpacing:2,marginBottom:8}}>
          {lang==="zh"?"专家咨询预约":"Book Expert Consultation"}
        </div>
        <div style={{fontSize:15,color:C.mist3,maxWidth:500,margin:"0 auto",lineHeight:1.7}}>
          {lang==="zh"
            ?"与资深命理师一对一深度解读，60分钟私人咨询。L2 Hybrid 套餐包含。"
            :"One-on-one deep reading with a senior practitioner. 60-minute private session included with L2 Hybrid tier."}
        </div>
      </div>

      <div style={{marginBottom:28}}>
        <div style={{fontSize:14,letterSpacing:2,color:C.goldDim,textTransform:"uppercase",marginBottom:14}}>
          {lang==="zh"?"我们的顾问团队":"Our Consultants"}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
          {consultants.map(c=>(
            <div key={c.name} style={{background:"rgba(255,255,255,.72)",border:"1px solid rgba(212,175,55,.16)",backdropFilter:"blur(12px)",borderRadius:10,padding:"20px 16px",textAlign:"center"}}>
              <div style={{width:52,height:52,borderRadius:"50%",background:`${c.color}22`,border:`1px solid ${c.color}44`,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",fontSize:16,fontWeight:"500",color:c.color,letterSpacing:1}}>{c.avatar}</div>
              <div style={{fontSize:15,color:C.mist,fontWeight:"500",marginBottom:4}}>{c.name}</div>
              <div style={{fontSize:12,color:c.color,marginBottom:8}}>{c.title}</div>
              <div style={{fontSize:12,color:C.mist4,lineHeight:1.6}}>{c.specialty}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
        <div style={{background:"rgba(255,255,255,.72)",border:"1px solid rgba(212,175,55,.18)",backdropFilter:"blur(16px)",borderRadius:14,padding:"28px 24px"}}>
          <div style={{fontSize:16,color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",marginBottom:18}}>
            {lang==="zh"?"预约信息":"Booking Details"}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div><span style={LS}>{lang==="zh"?"姓名":"Name"}</span>
              <input style={IS} value={form.name} onChange={set("name")} placeholder="Full name"/></div>
            <div><span style={LS}>{lang==="zh"?"邮箱":"Email"}</span>
              <input style={IS} type="email" value={form.email} onChange={set("email")} placeholder="your@email.com"/></div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div><span style={LS}>{lang==="zh"?"日期":"Date"}</span>
                <input style={IS} type="date" value={form.date} onChange={set("date")}
                  min={new Date(Date.now()+86400000).toISOString().split("T")[0]}/></div>
              <div><span style={LS}>{lang==="zh"?"时间 (EST)":"Time (EST)"}</span>
                <select style={IS} value={form.time} onChange={set("time")}>
                  <option value="">{lang==="zh"?"选择时间":"Select time"}</option>
                  {timeSlots.map(t=><option key={t} value={t}>{t}</option>)}
                </select></div>
            </div>
            <div><span style={LS}>{lang==="zh"?"主要关注":"Primary Concern"}</span>
              <select style={IS} value={form.concern} onChange={set("concern")}>
                <option value="">{lang==="zh"?"选择关注领域":"Select concern"}</option>
                <option value="career">{lang==="zh"?"事业与财运":"Career & Wealth"}</option>
                <option value="love">{lang==="zh"?"感情与婚姻":"Love & Relationships"}</option>
                <option value="health">{lang==="zh"?"健康与养生":"Health & Vitality"}</option>
                <option value="spiritual">{lang==="zh"?"修行与成长":"Spiritual Growth"}</option>
                <option value="general">{lang==="zh"?"综合咨询":"General Reading"}</option>
              </select></div>
            <div><span style={LS}>{lang==="zh"?"附加说明（可选）":"Additional Notes (optional)"}</span>
              <textarea style={{...IS,minHeight:80,resize:"vertical"}} value={form.message} onChange={set("message")}
                placeholder={lang==="zh"?"请描述您想了解的具体问题…":"Describe what you'd like to explore…"}/></div>
            <button style={{...BG,opacity:loading||!form.name||!form.email||!form.date||!form.time?0.6:1}}
              onClick={handleSubmit} disabled={loading||!form.name||!form.email||!form.date||!form.time}>
              {loading?"PROCESSING…":(!user||!["L2","L3","L4"].includes(user.tier))
                ?(lang==="zh"?"升级至 L2 并预约 · $600":"UPGRADE TO L2 & BOOK · $600")
                :(lang==="zh"?"确认预约":"CONFIRM BOOKING")}
            </button>
          </div>
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div style={{background:"rgba(255,255,255,.72)",border:"1px solid rgba(212,175,55,.18)",backdropFilter:"blur(16px)",borderRadius:14,padding:"24px 22px"}}>
            <div style={{fontSize:14,letterSpacing:2,color:C.goldDim,textTransform:"uppercase",marginBottom:14}}>
              {lang==="zh"?"咨询内容":"What's Included"}
            </div>
            {[
              {icon:"◎",label:lang==="zh"?"60分钟一对一深度解读":"60-min one-on-one deep reading",desc:lang==="zh"?"Zoom/微信视频通话":"Zoom or WeChat video call"},
              {icon:"◎",label:lang==="zh"?"完整命盘分析报告":"Full chart analysis report",desc:lang==="zh"?"八字+紫微+十神详解":"Bazi + Ziwei + Ten Gods breakdown"},
              {icon:"◎",label:lang==="zh"?"个性化修持方案":"Personalised practice protocol",desc:lang==="zh"?"本尊修持+饮食+颜色建议":"Deity yoga + diet + color guidance"},
              {icon:"◎",label:lang==="zh"?"闭关中心推荐":"Retreat centre recommendation",desc:lang==="zh"?"尼泊尔/越南/印度":"Nepal / Vietnam / India"},
              {icon:"◎",label:lang==="zh"?"无限AI顾问":"Unlimited AI advisor access",desc:lang==="zh"?"RAG知识库全开放":"Full RAG knowledge base access"},
              {icon:"◎",label:lang==="zh"?"会后文字总结":"Post-session written summary",desc:lang==="zh"?"72小时内发送":"Delivered within 72 hours"},
            ].map((item,i)=>(
              <div key={i} style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:14}}>
                <div style={{color:C.sage,fontSize:14,marginTop:2,flexShrink:0}}>{item.icon}</div>
                <div>
                  <div style={{fontSize:14,color:C.mist,marginBottom:2}}>{item.label}</div>
                  <div style={{fontSize:12,color:C.mist4}}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:"rgba(224,185,30,.10)",border:"1px solid rgba(212,175,55,.30)",borderRadius:10,padding:"18px 20px"}}>
            <div style={{fontSize:14,color:C.gold,marginBottom:8}}>
              {lang==="zh"?"L2 Hybrid 套餐 · $600 一次性":"L2 Hybrid · $600 one-time"}
            </div>
            <div style={{fontSize:13,color:C.mist3,lineHeight:1.7}}>
              {lang==="zh"
                ?"包含L1全部功能 + 60分钟专家咨询 + 无限AI顾问。如已是L2+会员，直接预约即可。"
                :"Includes everything in L1 + 60-min expert session + unlimited AI advisor. If you're already L2+, simply book your session."}
            </div>
          </div>

          <div style={{background:"rgba(255,255,255,.65)",border:"1px solid rgba(212,175,55,.14)",borderRadius:10,padding:"16px 20px"}}>
            <div style={{fontSize:13,color:C.mist4,lineHeight:1.7}}>
              {lang==="zh"
                ?"预约后24小时内收到确认邮件。如需更改时间，请至少提前48小时通知。所有咨询内容严格保密。"
                :"You'll receive a confirmation email within 24 hours. Reschedule at least 48 hours in advance. All sessions are strictly confidential."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsultantBookingPage;
